import isUrl from 'is-url';
import isAbsoluteUrl from 'is-absolute-url';
import psl from 'psl';

const isMailProtocol = (value: string) =>
  value.match(
    /^mailto:(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  );

export const getValidUrl = (value: string) => {
  let urlToSet = value;

  // add http(s) if the url is not absolute, but the domain is valid
  if (!isAbsoluteUrl(urlToSet)) {
    const urlToSetWithoutPortAndDoubleSlashes = urlToSet
      .split(':')[0]
      .replace(/^\/\//i, '');
    // check domain suffix is valid
    if (psl.isValid(urlToSetWithoutPortAndDoubleSlashes)) {
      urlToSet = urlToSet.replace(/^\/\//i, '');
      urlToSet = `https://${urlToSet}`;
    }
  }

  if (!isUrl(urlToSet) && !isMailProtocol(value)) {
    return false;
  }
  return urlToSet;
};
